'use client'
import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { UpSelling } from '@/components/cart/up-selling'
import { ListPriceItems } from '@/components/cart/list-price-items'
import { LayoutDiscount } from '@/components/layout/layout-discount'
import { formatAmountForDisplay } from '@/utils/stripe-helpers'
import { CURRENCY } from '@/config'
import { PaymentDetail } from '@/components/cart/payment-detail'
import {
  ProductDetail,
  Upselling,
  useProductStore,
} from '@/hooks/use-cart-product/store'

import {
  productFieldsSelector,
  promotionCodeSelector,
} from '@/hooks/use-cart-product/selectors'
import { twMerge } from 'tailwind-merge'

export function SubscriptionCart({
  products,
  upselling,
}: {
  products: ProductDetail
  upselling: Upselling
}): ReactElement {
  const [prodSelected, setProdSelected] = useState<ProductDetail>(products)
  const [productAmounts, setProductAmounts] = useState<{
    totalWithDiscount: number
    totalSubscription: number
  }>({
    totalWithDiscount: products.totalAmount,
    totalSubscription: products.subscriptionAmount,
  })

  const [showPromo, setShowPromo] = useState<boolean>(true)

  const promotion = useProductStore(promotionCodeSelector)

  const productStore = useProductStore(productFieldsSelector)

  useEffect(() => {
    if (productStore.currentProducts) {
      setProdSelected(productStore.currentProducts)
      setProductAmounts({
        totalWithDiscount: productStore.totalAmountWithDiscount,
        totalSubscription: productStore.currentProducts.subscriptionAmount,
      })
    }
  }, [
    productStore.currentProducts,
    productStore.totalAmountWithDiscount,
    productStore.currentProducts?.subscriptionAmount,
  ])

  useEffect(() => {
    setProductAmounts({
      totalWithDiscount: productStore.totalAmountWithDiscount,
      totalSubscription: productStore.currentProducts?.subscriptionAmount,
    })
    setShowPromo(!promotion?.code)
  }, [
    productStore.currentProducts,
    productStore.totalAmountWithDiscount,
    promotion?.code,
  ])

  return (
    <div className="sticky top-20 mb-2 p-2 md:mb-0">
      <div className="space-y-5 md:bg-white md:p-4">
        <p className="pt-2 text-start text-base font-normal">ESTÁS COMPRANDO</p>

        <div className="bg-white">
          <div
            className={twMerge(
              'bg-[#D9D9D9] bg-opacity-15',
              Object.keys(upselling).length === 0
                ? 'border-checkout-bk-op15 rounded-md border'
                : 'border-checkout-bk-op15 rounded-t-md border-l border-r border-t'
            )}>
            <div className="flex flex-col space-y-5 p-4">
              {prodSelected &&
                prodSelected.productsList.map((product, index) => {
                  return (
                    <ListPriceItems
                      key={index}
                      ninjaIconName={product.academy}
                      priceTitle={product.title}
                      priceSubTitle={product.subTitle}
                      price={product.amount}
                    />
                  )
                })}
            </div>

            <div className="px-4 md:hidden">
              <div className="flex flex-row justify-between">
                <p>Total a pagar</p>
                <div className="text-checkout-s text-checkout-bk-op50 flex flex-col items-end font-medium">
                  <p className="text-checkout-black text-2xl">
                    {formatAmountForDisplay(
                      productAmounts.totalWithDiscount,
                      CURRENCY
                    )}
                  </p>
                  <p className="pb-6">
                    {prodSelected?.period && (
                      <>
                        Luego{' '}
                        <span>
                          {formatAmountForDisplay(
                            productAmounts.totalSubscription,
                            CURRENCY
                          )}
                        </span>{' '}
                        {prodSelected?.period}
                      </>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {Object.keys(upselling).map((key) => (
            <UpSelling
              key={key}
              priceId={key}
              savingAmount={upselling[key].saving}
              description={`pagando el plan ${upselling[key].products.period}`}
              price={upselling[key].products.totalAmount}
              txtSidePrice={upselling[key].products.period}
            />
          ))}
        </div>
        <div className="hidden space-y-5 md:block">
          {showPromo && (
            <>
              <LayoutDiscount openDetail={false} />
              <hr className="border-1 border-checkout-bk-op20" />
            </>
          )}
          <PaymentDetail
            prods={prodSelected}
            amount={prodSelected.totalAmount}
            subscription={productAmounts.totalSubscription}
            period={prodSelected?.period}
          />
        </div>
      </div>
      {/*<ListReview />*/}
    </div>
  )
}
